import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { HR_NAV } from './nav';

const PolicyAttestation: React.FC = () => {
    const { api } = useInternalApi();
    const [policies, setPolicies] = useState<any[]>([]);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Policy Attestation - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('hr-api/policy-attestation/').then(r => {
            if (r.data?.status === 'success') {
                setPolicies(r.data.data.policies || []);
                setNote(r.data.data.note || '');
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="human_resources" subNav={HR_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faFileContract} className="me-2 text-primary" />Policy Attestation</h2>
            <p className="text-muted mb-4">Who still owes an attestation, by policy</p>

            <div className="alert alert-secondary small"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{note}</div>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : policies.length === 0 ? (
                <div className="card border-0 shadow-sm"><div className="card-body text-center py-5 text-muted">
                    No policies require attestation yet. Policies are published in the Compliance Center.
                </div></div>
            ) : (
                policies.map(p => {
                    const pct = p.eligible ? Math.round((p.attested / p.eligible) * 100) : 0;
                    return (
                        <div className="card border-0 shadow-sm mb-3" key={p.policy_id}>
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <h5 className="mb-1">{p.title} <span className="badge bg-light text-dark">v{p.version}</span></h5>
                                        <div className="small text-muted">Effective {p.effective_date || '—'}</div>
                                    </div>
                                    <span className={`badge bg-${pct === 100 ? 'success' : 'warning'}`}>{p.attested} of {p.eligible}</span>
                                </div>
                                <div className="progress mb-3" style={{ height: 8 }}>
                                    <div className={`progress-bar ${pct === 100 ? 'bg-success' : 'bg-warning'}`} style={{ width: `${pct}%` }} />
                                </div>
                                {p.outstanding.length === 0 ? (
                                    <div className="text-success small">Everyone has attested.</div>
                                ) : (
                                    <>
                                        <div className="small text-muted mb-1">Outstanding ({p.outstanding.length}):</div>
                                        <div className="d-flex gap-1 flex-wrap">
                                            {p.outstanding.map((n: string) => <span key={n} className="badge bg-warning">{n}</span>)}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })
            )}
        </InternalShell>
    );
};

export default PolicyAttestation;
